"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XPD_FALLBACK_MANIFEST = exports.DEFAULT_LANGUAGE = exports.CONCUR_NONCE_HEADER = void 0;
/*
Trusted domains used for setting Content Security Policy
Source: http://www.concurtraining.com/customers/tech_pubs/Docs/Z_SuppConfig/Supported_Configurations_for_Concur_Travel_and_Expense.pdf
Removed `DOMAINS_TRUSTED` as API Gateway is now managing CSP
*/

var XPD_FALLBACK_MANIFEST = exports.XPD_FALLBACK_MANIFEST = {
  'help-portal': {
    enabled: true,
    requiresSession: true,
    configOptions: {
      userAssistanceSettingsEnabled: false,
      cobrowsingEnabled: false,
      walkmeEnabled: false,
      liveChatEnabled: false
    },
    integrityHash: {
      js: {
        '/coreui/help-portal/help-portal-v1.5.0/help-portal-v1.5.0.js': 'sha384-/a8H/PDepDKlsP7OhUVNtok8cdQQXI2Xiwzq3FKG9rlVo+D3fwfD3hZhJEVvJw9l'
      },
      css: {}
    },
    files: {
      js: ['/coreui/help-portal/help-portal-v1.5.0/help-portal-v1.5.0.js'],
      css: []
    }
  },
  'on-screen-help': {
    enabled: false,
    requiresSession: true,
    integrityHash: {
      js: {
        '/on-screen-help/on-screen-help-v2.0.22-rc.7.js': 'sha384-oY8Z161eCuhgEgcy+yDzJi6lyje2e5sQn2E5Ll4GsT+doD3ZK7i3gYzUz/167qgQ'
      },
      css: {}
    },
    files: {
      js: ['/on-screen-help/on-screen-help-v2.0.22-rc.7.js'],
      css: []
    }
  },
  'ui-floorplans': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {
        '/coreui/ui-floorplans/ui-floorplans-v2.10.2/ui-floorplans-v2.10.2.js': 'sha384-vic17zW9VjUFAVoLZkyU7BRhYs4FIeopd3Y93Be0adhuiNh9YFjhFzhW2uKeKKLk'
      },
      css: {}
    },
    files: {
      js: ['/coreui/ui-floorplans/ui-floorplans-v2.10.2/ui-floorplans-v2.10.2.js'],
      css: []
    }
  },
  'monolith-widgets': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {
        '/coreui/monolith-widgets/monolith-widgets-v1.0.2/monolith-widgets-v1.0.2.js': 'sha384-6CeI2rDL0DPC4gkosAs/IUyd6DxRkMIlRtRaSXtiKRUGbu0wd2uMxhyXIlEQzbxi'
      },
      css: {}
    },
    files: {
      js: ['/coreui/monolith-widgets/monolith-widgets-v1.0.2/monolith-widgets-v1.0.2.js'],
      css: []
    }
  },
  'ui-custom-content': {
    enabled: true,
    requiresSession: true,
    configOptions: {
      targetSelectors: ['#company-notes-div']
    },
    integrityHash: {
      js: {
        '/coreui/ui-custom-content/ui-custom-content-v0.1.5/ui-custom-content-v0.1.5.js': 'sha384-SDQafSLEWff7lPGAm9Rcm2CNgjA9WDqxqxz0OAcPLJ3Y/mau87omuwq+ijpLoO4+'
      },
      css: {}
    },
    files: {
      js: ['/coreui/ui-custom-content/ui-custom-content-v0.1.5/ui-custom-content-v0.1.5.js'],
      css: []
    }
  },
  'translation-tool-ui': {
    enabled: true,
    requiresSession: true,
    integrityHash: {
      js: {
        '/coreui/translation-tool-ui/translation-tool-ui-v0.1.33/translation-tool-ui-v0.1.33.js': 'sha384-bhrqMpHQnMFKuc1MlEqWTwPLS1VCFT3QgGlq7hWx0GwtTQVxwdGeDp9PLaOmtYOL'
      },
      css: {}
    },
    files: {
      js: ['/coreui/translation-tool-ui/translation-tool-ui-v0.1.33/translation-tool-ui-v0.1.33.js'],
      css: []
    }
  },
  'ui-theming': {
    enabled: true,
    requiresSession: false,
    integrityHash: {
      js: {},
      css: {
        '/coreui/ui-theming/ui-theming-v3.1.0/concur_android/css_variables.css': 'sha384-NH99QqObSXK/PS6Jx60szJgyYau3yXsg39TKoJ6g9Kext4EHk6HjekZUMD1iTwe9',
        '/coreui/ui-theming/ui-theming-v3.1.0/concur_gateway/css_variables.css': 'sha384-iICcIUjvBsyNdy7Vm3u7NphAySc9t+m2+m85o/UaH7Qi0Z5Lr9w/mkO86OSNn7e1',
        '/coreui/ui-theming/ui-theming-v3.1.0/concur_ios/css_variables.css': 'sha384-4HZ5hynchpWcnQw4tzhB+9qOwkSwOMTppLqvR3w4BUh5i0L+dgLYbQRvXIizGb6a',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3/css_variables.css': 'sha384-5/OATG5wizJQrvoNdh35+kzWJbypLO8cvbCdb8oGKAtjDDUZlOqx2ORDivtdPEEH',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_dark/css_variables.css': 'sha384-FNZTmvZ8wgaZBqq7EFbjHYVQ/Kk5tSUDPryTHkBOUfHl95IjU23hcNWaN4BoMe5p',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_hcb/css_variables.css': 'sha384-dxFGOhF3L2wUNwygmCBGAlApQ70frS27oeoiGbDHOGXcXcSmRHRTT3TEFSyRXD3V',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_hcw/css_variables.css': 'sha384-bC+aldfLzYyXVXJpKHk4n0ahZ7wsd35v1p2Bt2aCJoWbzGnlNvyB3yCqTR8Dwvi3',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon/css_variables.css': 'sha384-HuLPSiz8aNPc+MpJ1JitTAZDCZRoyeUEL8M450GcsRWAgCGCFbTW1/L7x3NrufQ1',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_dark/css_variables.css': 'sha384-zfI3wN1rBVrKz9XZJDiBoy+TI9XdwbOm1egWmVRKQKv9w7FaWuo3ApObFNE22qjB',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_hcb/css_variables.css': 'sha384-+0codtaeP++aSrXBjyVOqP+ceFh5G1TvUjfKprg9K1GRaTz1g8eCJcHaSth0nVda',
        '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_hcw/css_variables.css': 'sha384-6bJKr1Wt/jpO8C8a3fR+hNbO+lm2LCJSQhG+R6rS2bmHu+G7pYpjGUnrTZmv8yAh'
      }
    },
    files: {
      js: [],
      css: ['/coreui/ui-theming/ui-theming-v3.1.0/concur_android/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/concur_gateway/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/concur_ios/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_dark/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_hcb/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_fiori_3_hcw/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_dark/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_hcb/css_variables.css', '/coreui/ui-theming/ui-theming-v3.1.0/sap_horizon_hcw/css_variables.css']
    }
  }
};
var CONCUR_NONCE_HEADER = exports.CONCUR_NONCE_HEADER = 'concur-csp-nonce';
var DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = 'en';